<template>
    <form class="form-horizontal" @submit.prevent="handleSubmit">
        <div class="row">
            <div class="col-lg-12">
                <div class="row">
                    <label class="col-md-3 col-form-label">Current Password*</label>
                    <div class="col-md-8">
                        <fg-input
                            v-model="form.currentPassword"
                            v-validate="modelValidations.currentPassword"
                            :error="getError('currentPassword')"
                            data-vv-validate-on="blur"
                            name="currentPassword"
                            autoComplete="off"
                            type="password"
                        >
                        </fg-input>
                    </div>
                </div>
            </div>
            <div class="col-lg-12">
                <div class="row">
                    <label class="col-md-3 col-form-label">New Password*</label>
                    <div class="col-md-8">
                        <fg-input
                            ref="password"
                            v-model="form.password"
                            v-validate="modelValidations.password"
                            :error="getError('password')"
                            data-vv-validate-on="blur"
                            name="password"
                            autoComplete="off"
                            type="password"
                        >
                        </fg-input>
                    </div>
                </div>
            </div>
            <div class="col-lg-12">
                <div class="row">
                    <label class="col-md-3 col-form-label">Confirm New Password*</label>
                    <div class="col-md-8">
                        <fg-input
                            v-model="form.confirmPassword"
                            v-validate="modelValidations.confirmPassword"
                            :error="getError('confirmPassword')"
                            data-vv-validate-on="blur"
                            name="confirmPassword"
                            autoComplete="off"
                            type="password"
                        >
                        </fg-input>
                    </div>
                </div>
            </div>
        </div>

        <div slot="footer" class="row">
            <label class="col-md-3 col-form-label"></label>
            <div class="col-md-3">
                <p-button slot="footer" :disabled="loading" nativeType="submit" type="primary" block class="mb-3">
                    <i v-if="loading" class="fa fa-circle-o-notch fa-spin"></i>
                    {{ loading ? null : 'Submit' }}
                </p-button>
            </div>
        </div>
    </form>
</template>
<script>
import { Validator } from 'vee-validate'
import { clearFields } from '@/utils'
import { getError } from '@/utils/validateErrors'
import { Checkbox, Button } from '@/components/UIComponents'
export default {
    components: {
        [Checkbox.name]: Checkbox,
        [Button.name]: Button
    },
    props: {
        loading: Boolean,
        shouldClear: Boolean
    },
    data() {
        return {
            form: {
                currentPassword: '',
                password: '',
                confirmPassword: ''
            },
            modelValidations: {
                currentPassword: {
                    required: true,
                    min: 6
                },
                password: {
                    required: true,
                    min: 6
                },
                confirmPassword: {
                    required: true,
                    min: 6,
                    confirmed: 'password'
                }
            }
        }
    },
    created() {
        const dictionary = {
            en: {
                attributes: {
                    currentPassword: 'current password',
                    password: 'password',
                    confirmPassword: 'confirm password'
                }
            }
        }
        Validator.localize(dictionary)
    },
    methods: {
        getError,
        async handleSubmit() {
            const isValid = await this.$validator.validateAll()
            if (isValid) {
                const values = {
                    currentPassword: this.form.currentPassword,
                    password: this.form.password,
                    confirmPassword: this.form.confirmPassword
                }
                this.$emit('submit', values)
                if (this.shouldClear) {
                    this.form = clearFields(this.form)
                    this.$validator.reset()
                }
            }
        }
    }
}
</script>
